export const companyProducts = [
  {
    label: "Crypto",
    key: "1",
    path: "/products/crypto",
  },
  {
    label: "Giftcard",
    key: "2",
    path: "/products/giftcard",
  },
  {
    label: "Bill Payments",
    key: "3",
    path: "/products/bill-payments",
  },
];

export const companyRoutes = [
  { label: "Home", key: "home", path: "/" },
  { label: "About", key: "about", path: "/about" },
  { label: "Privacy Policy", key: "privacy-policy", path: "/privacy-policy" },
  {
    label: "Terms and Conditions",
    key: "terms-and-conditions",
    path: "/terms-and-conditions",
  },
];
